// src/utils/acquisitionApi.js
//
// What the accounts that came from a landing page or Google Ads do
// afterwards: verified ratings and « Afficher le QR » taps, per page and
// keyword (backend routes/adminAcquisition.ts, admins only).
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export async function acquisitionStats(days, token) {
  const r = await fetch(`${API_BASE_URL}/admin/acquisition?days=${days}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP_${r.status}`);
  return data;
}
